import auth, { TokenPayload } from '@/services/auth';
import search from '@/services/search';
import user from '@/services/user';

interface IState {
  user: {
    id?: string;
    email?: string;
  };
}

export default ({
  trackMutations,
}: any) => {

  // Refresh token every x minutes
  // Must be below server's token expiry time (1 day)
  auth.refreshTokenInterval(5);

  trackMutations({
    LOGIN: (token: string) => null,
  });

  return {
    namespaced: true,
    state: {
      user: user.getFromSession(),
    } as IState,
    getters: {
      // store user id seperately as user getter updates everytime
      userId: (state: IState) => state.user.id,
      user: (state: IState) => state.user,
    },
    mutations: {
      LOGIN(state: IState) {
        state.user = user.getFromSession();
      },
      LOGIN_ATTEMPT(state: IState) {
        state.user = user.getFromSession();
      },
      LOGOUT(state: IState) {
        auth.clearToken();
        search.clearHistory();
        state.user = {};
      },
    },
    actions: {
      attemptLogin: ({ commit }: any, email: string) => (
        auth
          .attemptLogin(email)
          .then(response => {
            commit('LOGIN_ATTEMPT');
            return response;
          })
      ),
      login: ({ commit }: any, payload: TokenPayload) => (
        auth
          .getNewToken(payload)
          .then(() => commit('LOGIN'))
      ),
      logout: ({ commit }: any) => commit('LOGOUT'),
    },
  };
};
